import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Sortable controller for drag-and-drop reordering with optional server sync
// Usage:
//   data-controller="sortable"
//   data-sortable-url-value="/path/to/reorder"
//   data-sortable-handle-value=".handle" (optional)
export default class extends Controller {
  static values = {
    handle: { type: String, default: "" },
    animation: { type: Number, default: 150 },
    url: { type: String, default: "" }
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: this.handleValue || undefined,
      animation: this.animationValue,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      dragClass: "sortable-drag",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  onEnd(event) {
    const items = Array.from(this.element.children)
    const ids = items.map(item => item.dataset.sortableId).filter(Boolean)

    // If URL is provided, sync with server
    if (this.urlValue) {
      this.syncOrder(ids)
    }

    // Dispatch a custom event
    this.element.dispatchEvent(new CustomEvent("sortable:end", {
      bubbles: true,
      detail: {
        ids: ids,
        oldIndex: event.oldIndex,
        newIndex: event.newIndex
      }
    }))
  }

  async syncOrder(ids) {
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ ids: ids })
      })

      if (!response.ok) {
        console.error("Failed to save order")
      }
    } catch (error) {
      console.error("Error saving order:", error)
    }
  }
}
